//$('.table--scrollable').wrapAll('<div class="scrollable"></div>');
import { onAvailable } from "@core/plugins/lib/selectors";

const ELEMENT_SELECTOR = '.table--scrollable';
$(() => {
    onAvailable.ready(ELEMENT_SELECTOR, function (element) {
        $(element).wrapAll('<div class="scrollable"></div>');
    });
});


// WEBPACK FOOTER //
// ./project/client/src/site__ale001/components/wysiwyg/tables.js